import { fieldKeysOfEntitiesWithFontAwesomeSelectors } from "common/constants/fontAwesomeConst";
import { fontAwesomeIconsCssRules } from "server/constants/fontAwesomeIconsCssRules";
import { fontAwesomeIconsCssRulesDeclarationsArray } from "server/constants/fontAwesomeIconsCssRulesDeclarationsArray";
import { EntitiesType } from "server/types/ServerPageInterface";

export const findFontAwesomeSelectorsInEntities = (entities: EntitiesType) => {
  const stringsWithFontAwesomeSelectors: string[] = [];
  function goThroughAllEntitiesFields(object: any) {
    for (let key in object) {
      if (object.hasOwnProperty(key)) {
        if (typeof object[key] == "object") {
            goThroughAllEntitiesFields(object[key]);
        } else if (fieldKeysOfEntitiesWithFontAwesomeSelectors.includes(key)) {
          stringsWithFontAwesomeSelectors.push(object[key])
        }
      }
    }
  }
  goThroughAllEntitiesFields(entities)

  const fontAwesomeSelectors = new Set<string>();
  stringsWithFontAwesomeSelectors?.forEach((stringsWithFontAwesomeSelector) => {
    stringsWithFontAwesomeSelector.match(/fa[-\w]+/g)?.forEach((classname) => {
      // NOTE: "classname" example: "fa-duotone", "fa-swap-opacity"
      classname && fontAwesomeSelectors.add(classname);
    });
  });
  stringsWithFontAwesomeSelectors?.forEach((stringsWithFontAwesomeSelector) => {
    stringsWithFontAwesomeSelector.match(/fa[-\w]+(?:\s+fa[-\w]+)+/g)?.forEach(
      (descendantCombination) => {
        // NOTE: "descendantCombination" example: "fad fa-album-circle-plus", "fa-duotone fa-swap-opacity"
        descendantCombination && fontAwesomeSelectors.add(descendantCombination);
      }
    );
  });
  return [...fontAwesomeSelectors];
};

export const fontAwesomeHtmlStylesGenerator = (fontAwesomeSelectors: string[]) => {
  const result = new Set<string>([])
  fontAwesomeSelectors.forEach((selector) => {
    const fontAwesomeIconsCssRule = fontAwesomeIconsCssRules[selector as keyof typeof fontAwesomeIconsCssRules]
    if (fontAwesomeIconsCssRule) {
      fontAwesomeIconsCssRule.forEach(([selector, declarationIndex]) =>{
        result.add(`.${selector.replace(' ', '.')}{${fontAwesomeIconsCssRulesDeclarationsArray[declarationIndex]}}`)
      })
    }
  })
  return [...result].join('')
}
